/* eslint-disable max-len */
import Page from 'front/pages/Page/Page';
import Urls from 'django_js_front/reverse.js';
import * as _ from 'underscore';

import TopBar from 'front/components/Common/TopBar/TopBar';
import Intro from 'front/components/IndexComponents/Intro/Intro';
import Content from 'front/components/IndexComponents/Content/Content';
import Illustrations from 'front/components/IndexComponents/Illustrations/Illustrations';
import Animations from 'front/components/IndexComponents/Animations/Animations';
import Storyboards from 'front/components/IndexComponents/Storyboards/Storyboards';

import { VIEWPORT_EVENTS } from '../../constants/Constants';
import './Index.less';
import axios from 'axios';
import * as Template from './Index.jinja';

const Selectors = {
    el: '.Index',
    item: '.IndexAnimations-item img',
    itemPlay: '.IndexAnimations-item svg',
    frame: '.IndexAnimations-itemFrame'
};

const BindFunctions = [
    'onLoad'
];

export default class Index extends Page {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.item}`]: this.onItem,
            [`${VIEWPORT_EVENTS.click} ${Selectors.itemPlay}`]: this.onItemPlay
        };
    }

    constructor(options = {}) {
        options.el = Selectors.el;
        options.VIEWS_TO_REGISTER = {
            'top-bar': { selector: '.TopBar', viewConstructor: TopBar },
            'intro': { selector: '.Intro', viewConstructor: Intro },
            'content': { selector: '.IndexContent', viewConstructor: Content },
            'illustrations': { selector: '.IndexIllustrations', viewConstructor: Illustrations },
            'animations': { selector: '.IndexAnimations', viewConstructor: Animations },
            'storyboards': { selector: '.IndexStoryboards', viewConstructor: Storyboards }
        };
        options.template = Template;
        super(options);
        _.bindAll(this, BindFunctions);

        setTimeout(() => {
            axios.get(Urls['front:api:index-animations'](),
                {
                    params: {
                        language: window.app.settings.language
                    }
                }).then(response => {
                this.onLoad(response?.data);
            });
        }, 1000);
    }

    onItem(e) {
        this.showAndPlayVideo(e.currentTarget);
    }

    onItemPlay(e) {
        this.showAndPlayVideo(e.currentTarget);
    }

    showAndPlayVideo(clickedElement) {
        const $parent = $(clickedElement).parent();
        $parent.find('img, svg').addClass('hide');
        const $iframe = $parent.find('iframe');
        $iframe.removeClass('hide');

        // Получаем текущий src
        const currentSrc = $iframe[0].src;

        // Проверяем, содержит ли URL уже параметры запроса
        if (currentSrc.includes('?')) {
            // Если уже есть параметры, добавляем параметр autoplay через &
            $iframe[0].src = currentSrc + '&autoplay=1';
        } else {
            // Если параметров нет, добавляем параметр autoplay через ?
            $iframe[0].src = currentSrc + '?autoplay=1';
        }
    }

    onLoad(data) {
        const regExpVimeo = /:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
        const regExpYoutube = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const regExpKinescope = /:\/\/(www\.)?kinescope.io\/embed\/([a-zA-Z0-9]+)/;

        if (data) {
            data.forEach((item, index) => {
                let videoId;
                let embedUrl;

                if (item.video.indexOf('youtube') !== -1) {
                    let match = item.video.match(regExpYoutube);
                    videoId = match[7];
                    embedUrl = `https://www.youtube.com/embed/${videoId}`;
                } else if (item.video.indexOf('vimeo') !== -1) {
                    let match = item.video.match(regExpVimeo);
                    videoId = match[2];
                    embedUrl = `https://player.vimeo.com/video/${videoId}`;
                } else if (item.video.indexOf('kinescope') !== -1) {
                    // Если видео из Kinescope, извлекаем ID видео
                    let match = item.video.match(regExpKinescope);
                    if (match && match[2]) {
                        videoId = match[2];
                        embedUrl = `https://kinescope.io/embed/${videoId}`;
                    } else {
                        // Если не удалось извлечь ID, используем весь URL как есть
                        embedUrl = item.video;
                    }
                } else {
                    // Для других случаев используем URL как есть
                    embedUrl = item.video;
                }

                const $frame = this.$(Selectors.frame).eq(index);
                $frame.html(`
                    <iframe src="${embedUrl}" 
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowfullscreen
                            class="hide">
                    </iframe>
                `);
            });
        }
    }
}
